module.exports = __webpack_public_path__ + "img/svb.7d78efcd.png";